var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 20.134-1.286-1.167c-4.565-4.143-7.579-6.874-7.579-10.224a4.83 4.83 0 0 1 4.876-4.876A5.3 5.3 0 0 1 12 5.72a5.3 5.3 0 0 1 3.989-1.853 4.83 4.83 0 0 1 4.876 4.876c0 3.351-3.014 6.081-7.579 10.23Z"
  })));
};
export default SvgHeartFilled;